export default {

    // 応募状況詳細
    applyStatusDetail: {},
    // 0:waiting 1:loading 2:success 3:failed
    applyStatusDetailLoadStatus: 0,

    saveApplyStatusDetailStatus: 0,
    saveApplyTechStatus: 0,

    /** 契約画面 **/
    contractInfo: {},
    // create/create_confirm/show/edit/edit_confirm
    contractOperat: "",
    // 0:waiting 1:loading 2:success 3:failed
    saveContractInfoStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    contractInfoLoadStatus: 0,

    /** 応募詳細画面 **/
    // 応募詳細
    appDetail: {},
    // 0:waiting 1:loading 2:success 3:failed
    appDetailLoadStatus: 0,

    // 公開単価設定
    // 0:waiting 1:loading 2:success 3:failed
    appPricePubStatus: 0,

    // 氏名公開設定
    // 0:waiting 1:loading 2:success 3:failed
    appNamePubStatus: 0,

    // 応募情報承認
    // 0:waiting 1:loading 2:success 3:failed
    approvalApplyStatus: 0,

    // 入場確定
    enterConfirmStatus: 0,

    // 面接・入場取消
    // 0:waiting 1:loading 2:success 3:failed
    cancelIntvStatus: 0,

    /** 契約期間 **/
    contractPeriodSaveStatus: 0,

    /** 現場中など**/
    workStatus: {},
    workStatusSelected: [],
    workStatusLoadStatus: 0,

    /** 退場確定 **/
    exitConfirmSaveStatus: 0,

    /** 退場済みに変更 **/
    changeToExitedStatus: 0,

    // 対応後の最新apply_postを一覧に反映
    newApplyPost: {},
    addedInterview: {},
    // 0:waiting 1:loading 2:success 3:failed
    addInterviewStatus: 0,

    addedEntrance: {},

    // 0:waiting 1:loading 2:success 3:failed
    addNoteStatus: 0,

    // 0:waiting 1:loading 2:success 3:failed
    sendMailDocNGStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    sendMailIntvNGStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    sendMailIntvOKStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    sendMailIntvOKWithNextStatus: 0,

    // 入場予定詳細
    enterDetail: {},
    // 0:waiting 1:loading 2:success 3:failed
    enterDetailLoadStatus: 0,





    
}
